import styled from 'styled-components';
import InningState from '@mlb/react-patterns/v4/components/InningState/inningState';
import {
    PlayerNameWrapper,
    PlayerStatsWrapper,
    PlayerInfoWrapper,
    PlayerDataWrapper
} from '@mlb/react-patterns/v4/components/PlayerMatchup/playerMatchup.style';
import { liveViewsTypes } from '../themes/liveViewsTypes';

const { SINGLENARROW, FULLNARROW } = liveViewsTypes;
const PREVIEW = 'preview';

export const PlayerDuelWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    margin: 0 auto;
    margin-top: ${({ $type }) => ($type === SINGLENARROW) ? '16px' : '0'};

    ${({ $gameState }) => {
        if ($gameState === PREVIEW) {
            return `
                min-width: 264px;
            `;
        }
    }};
 

    ${PlayerDataWrapper} {
        ${({ $gameState }) => ($gameState !== PREVIEW && 'height: 64px')};

        ${({ $type }) => {
        if ($type === SINGLENARROW) {
            return `
                    height: auto;
                `;
        }
    }};
    }

    ${PlayerStatsWrapper} {
        font-size:  14px;
        color: var(--gameday-secondary-font-color);
        white-space: nowrap;
        height: 12px;
        margin-top: 10px;

        ${({ $type }) => {
            if ($type === SINGLENARROW || $type === FULLNARROW) {
                return `
                margin-top: 4px;
                    `;
            }
        }};
        
        ${({ $gameState }) => {
        if ($gameState !== PREVIEW) {
            return `
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    text-align: left;
                `;
        } else {
            return `
                    min-height: 48px;
                `;
        }
        }};

        .before-list {
            display: inline-block;
        }
        .after-list {
            display: inline-block;
            margin-top: ${({ $gameState }) => ($gameState === PREVIEW ? '0' : '8px')};
        }
    }

    ${PlayerInfoWrapper} {
        white-space: nowrap;
        height: ${({ $gameState }) => ($gameState === PREVIEW ? '' : '14px')};
        
        ${({ $type, $gameState }) => {
        if ($type === SINGLENARROW || $type === FULLNARROW) {
            return `
                    justify-content: center;
                `;
        } else {
            return `
                    justify-content: ${$gameState === PREVIEW ? 'center' : 'flex-start'};
                    margin-top: ${$gameState === PREVIEW ? '0px' : '2px'};
                `;
        }
    }};
    }

    ${({ $gameState }) => {
        if ($gameState === PREVIEW) {
            return `
                ${PlayerStatsWrapper} {
                    color: var(--gameday-primary-font-color);
                    font-weight: 700;
                    font-size: 14px;
                    line-height: 14px;
                    
                    div {
                        margin-top: 4px;
                    }
                }
            `;
        }
    }};
`;

export const ProbablePitcherInfoWrapper = styled.div`
    font-weight: 700;
    font-size: 14px;
    line-height: 14px;
    color: var(--gameday-secondary-font-color) !important;
    margin-top: 0 !important;
    margin-bottom: 5px;
`;

export const NameWrapper = styled(PlayerNameWrapper)`
    display: block !important;
`;

export const StatsWrapper = styled(PlayerStatsWrapper)`
    display: block !important;
`;

export const MatchupWrapper = styled.div`
    display: flex;
    justify-content: ${({ $type }) => ($type === SINGLENARROW || $type === FULLNARROW) ? 'space-evenly' : 'space-between'};
    padding: 16px 0;
    border-bottom: ${({ showUpcomingBatters }) => showUpcomingBatters ? 'solid 1px var(--gameday-divider-color)' : '0'};
    border-top: ${({ showUpcomingBatters }) => showUpcomingBatters ? 'solid 1px var(--gameday-divider-color)' : '0'};
    width: ${({ $gameState }) => ($gameState === PREVIEW ? '334px' : '100%')};
    margin: ${({ $gameState }) => ($gameState === PREVIEW ? '0 auto' : '0')};
    ${({ $type, $gameState, showUpcomingBatters }) => {
        if ($gameState !== PREVIEW && $type !== SINGLENARROW && $type !== FULLNARROW && !showUpcomingBatters) {
            return 'align-items: center';
        } else {
            return 'align-items: flex-start';
        }
    }}
`;

export const PlayerDuelStatsWrapper = styled.span`
    text-transform: uppercase;
    vertical-align: top;
    font-weight: bold;
    font-size: 12px;
    line-height: 12px;
    height: 12px;
    margin-top: 4px;
    color: var(--gameday-secondary-font-color);
`;

export const PlayerDuelStatsDash = styled.span`
    margin-top: 4px;
`;

export const StatsDividerWrapper = styled.span`
    margin: 0 5px;
    color: var(--gameday-divider-color);
`;

export const MatchupStateWrapper = styled.div`
    min-width: 44px;
    span {
        display: block;
        color: var(--gameday-primary-font-color);
        line-height: 15px;
        text-align: center;
        font-family: var(--gameday-primary-font);
        font-weight: 700;
        font-feature-settings: 'tnum';
        white-space: nowrap;
        
    }
    ${({ $gameState, $type }) => {
        if ($gameState !== PREVIEW) {
            return `
                font-size: ${$type === SINGLENARROW ? '12px' : '16px'};
                height: 64px;
                width: auto;
                display: flex;
                flex-direction: column;
                height: ${$type === SINGLENARROW ? '47px' : '59px'};
                justify-content: space-between;
                align-items: center;
            `;
        } else {
            return `
            font-size: 14px;
            height: 96px;
            span {
                position: relative;
                transform: translateY(-50%);
                top: 50%;
            }
        `;
        }
    }};
`;

export const InningStateOverride = styled(InningState)`
    &&& {
        margin: 0 auto;
    }
`;

export const OutsWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;
